import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=a879daba&scoped=true&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a879daba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a879daba')) {
      api.createRecord('a879daba', component.options)
    } else {
      api.reload('a879daba', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=a879daba&scoped=true&", function () {
      api.rerender('a879daba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/reporting-channel/config/Form.vue"
export default component.exports